export const environment = {
  api_root: 'https://pco-laas-middleware-prod.puntoscolombia.com/api',
  captcha: '6Ld1o6YrAAAAAN0eY3PZjH1X2tYFymxOkcGEd6mv',
  env: 'prod',
  microservices_versions: {
    incentives: 'v1',
  },
  production: true,
  version: '1.0.0',
  sso_url: 'https://sso.puntoscolombia.com/login'
};